/**
 * «Lista | Calendario»: las dos vistas de Campañas (fase 3 del plan de campañas, 29/10/2026). Son dos links, porque cada
 * vista tiene su URL; la que se está mirando, marcada. El canal elegido pasa de una a la otra.
 */

import { Link } from "react-router-dom";
import { CalendarDays, List } from "lucide-react";
import { R_CAMPANAS } from "../logic/campanas";
import { R_CALENDARIO } from "../logic/calendario";
import type { Canal } from "../types";

const VISTAS = [
  { id: "lista", texto: "Lista", ruta: R_CAMPANAS, icono: List },
  { id: "calendario", texto: "Calendario", ruta: R_CALENDARIO, icono: CalendarDays },
] as const;

export function VistaCampanas({ actual, canal }: { actual: (typeof VISTAS)[number]["id"]; canal?: Canal }) {
  return (
    <nav aria-label="Ver las campañas en" className="inline-flex rounded-xl border border-slate-200 bg-white p-0.5" data-testid="vista-campanas">
      {VISTAS.map(({ id, texto, ruta, icono: Icono }) => (
        <Link
          key={id}
          to={canal ? `${ruta}?canal=${canal}` : ruta}
          aria-current={actual === id ? "page" : undefined}
          className={`min-h-[44px] px-4 rounded-lg inline-flex items-center gap-2 text-sm font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 ${
            actual === id ? "bg-violet-600 text-white" : "text-slate-700 hover:bg-slate-50"
          }`}
        >
          <Icono size={16} aria-hidden="true" />
          {texto}
        </Link>
      ))}
    </nav>
  );
}
